window.hoculus = window.hoculus || {};
if (console && console.log) {
	console.log(
		"Supported by %cHoculus srl %con %cShopify %c- %c" +
			Shopify.theme.name +
			" %c -> https://www.hoculus.com",
		"color: red; font-weight: bold",
		"color: unset",
		"color: green",
		"color: unset",
		"color: blue",
		"color: unset; font-weight: bold"
	);
}

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "€{{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

hoculus.utils = class {
	static getScript(source, callback) {
		hoculus.loadedScripts = hoculus.loadedScripts || [];
		if (hoculus.loadedScripts.includes(source)) {
			setTimeout(callback, 0);
		} else {
			var script = document.createElement("script");
			var prior = document.getElementsByTagName("script")[0];
			script.defer = 1;

			script.onload = script.onreadystatechange = function (_, isAbort) {
				if (
					isAbort ||
					!script.readyState ||
					/loaded|complete/.test(script.readyState)
				) {
					script.onload = script.onreadystatechange = null;
					script = undefined;

					if (!isAbort && callback) setTimeout(callback, 0);
				}
			};
			script.src = source;
			prior.parentNode.insertBefore(script, prior);
		}
	}
	async getScriptAsync(source) {
		hoculus.loadedScripts = hoculus.loadedScripts || [];
		return await new Promise(function (resolve, reject) {
			if (hoculus.loadedScripts.includes(source) || source == '') {
				resolve(true);
			} else {
				var script = document.createElement("script");
				var prior = document.getElementsByTagName("script")[0];
				script.defer = 1;

				script.onload = script.onreadystatechange = function (_, isAbort) {
					if (
						isAbort ||
						!script.readyState ||
						/complete/.test(script.readyState)
					) {
						script.onload = script.onreadystatechange = null;
						script = undefined;

						if (!isAbort) setTimeout(resolve(true), 50);
					}
				};

				script.src = source;
				prior.parentNode.insertBefore(script, prior);
			}
		});
	}
	insertScriptTag(html) {
		let script = document.createElement("script");
		let head = document.getElementsByTagName("head")[0];
		script.innerHTML = html;
		head.appendChild(script);
	}
	insertCss(css) {
		let link = document.createElement("link");
		link.setAttribute("rel", "stylesheet");
		link.setAttribute("href", css);
		document.head.appendChild(link);
	}
	async waitFunction(wfunction) {
		let _this = this;
		this.check = function () {
			if (typeof wfunction == "function") {
				resolve(true);
			} else {
				setTimeout(_this.check(), 50);
			}
		};
		return await new Promise(function (resolve, reject) {
			_this.check();
		});
	}
	async waitElement(selector) {
		return await new Promise(function (resolve, reject) {
			var check = function () {
				if (document.querySelector(selector) !== null) {
					resolve(true);
				} else {
					setTimeout(check, 50);
				}
			};
			check();
		});
	}
	static async addToCart(items) {
		return new Promise(function (resolve, reject) {
			let bodyItems = JSON.stringify({
				items: items,
			});

			fetch("/cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: bodyItems,
			})
				.then((response) => {
					return response.json();
				})
				.catch((error) => {
					console.error("Error during the add in cart: ", error);
					reject(false)
				})
				.finally((res) => {
					hoculus.cartProgress(res)
					document.dispatchEvent(new CustomEvent("hoculus:product:add"));
					resolve(true);
				});
		});
	}
	static onInteraction () {
		hoculus.classes = hoculus.classes || {};
		hoculus.interacted = hoculus.interacted || false;
		if(!hoculus.interacted){
			new hoculus.whatsapp();

			hoculus.interacted = true;
		}
	}
	blockBtn(btn) {
		btn.setAttribute("disabled", true);
		btn.style.minWidth = btn.offsetWidth + "px";
		btn.style.minHeight = btn.offsetHeight + "px";
		let btnTxt = btn.querySelector("span.btn-txt");
		btnTxt.style.display = "none";
		var loader = document.createElement("div");
		loader.innerHTML = hoculus.components.loader;
		btnTxt.parentElement.insertBefore(loader.firstChild, btnTxt);
	}
	unlockBtn(btn) {
		btn.removeAttribute("disabled");
		let btnTxt = btn.querySelector("span.btn-txt");
		btnTxt.style.display = "block";
		btnTxt.previousSibling.remove();
		btn.style.minWidth = "unset";
		btn.style.minHeight = "unset";
	}
	static async getCart() {
		return await new Promise((resolve, reject) => {
			fetch("/cart.js", {
				credentials: "same-origin",
				method: "GET",
			})
			.then(function (resp) {
				resolve(resp.json())
			}).catch((err) => reject(false))
		}) 
	}
	static domready(callback) {
		if (document.readyState == "complete") callback();
		else document.addEventListener("DOMContentLoaded", callback);
	}
	static async domreadyState(){
		return await new Promise(function (resolve, reject) {
			document.onreadystatechange = () => {
			  if (document.readyState === 'complete') {
			    resolve(true);
			  }
			}
		})
	}
};
hoculus.whatsapp = class extends hoculus.utils {
    constructor() {
        super()
        this.selector = "#whatsapp-button";
        this.dataKey = "whatsappSettings";
        this.init();
    }
    async init() {
        await super.getScriptAsync(hoculus.assets.js.jquery)
        this.node = $(this.selector)
        if(!this.node) return;
		this.options = this.node.data(this.dataKey)
		super.insertCss(hoculus.themeData.floatingWppCss);
		await super.getScriptAsync(hoculus.themeData.floatingWppJs);
        this.insert()
    }
    insert() {
        this.node.floatingWhatsApp(this.options);
        this.node.show();
        this.node.css('display', 'block')
    }
}


hoculus.Shipping = class extends hoculus.utils {
	constructor() {
	   super();
	   this.config = {
		   forecast: hoculus.settings.forecast,
		   selector: ".shipping-forecast strong",
		   placeholder: "[DATA]"
		}
	   this.runForecast();
   }
   runForecast () {
		this.container = document.querySelector(this.config.selector)
		this.forecastDay = this.getForecast();
		if(!this.container) return;
		this.container.innerText = 1 === this.config.forecast.daysRange.split("-").length ? this.config.forecast.shippingMessage.replace(this.config.placeholder, this.forecastDay[0]) : this.container.innerText = this.config.forecast.shippingMessage.replace(this.config.placeholder, "tra " + this.forecastDay[0] + " e " + this.forecastDay[1]);
   }
   	dayIncrement(weekdays, startDay, addDays) {
		var day = startDay;
		while (weekdays[day] == false) {
			addDays += 1
			var nextIndex = Object.keys(weekdays).indexOf(day) + 1;
			if (nextIndex >= Object.keys(weekdays).length) {
				nextIndex = 0;
			}
			day = Object.keys(weekdays)[nextIndex];
		}
		return {day, addDays};
	}
   getForecast () {
	   this.available_days = (!this.config.forecast.shippingDays ? 'lunedì,martedi,mercoledì,giovedì,venerdi' : this.config.forecast.shippingDays).split(",");
	   let deliveryDays = {},
		   weekdays = ['lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato', 'domenica'],
		   days_range = this.config.forecast.daysRange.split("-"),
		   addDays_min = parseInt(days_range[0]),
		   addDays_max = parseInt(days_range[1]),
		   todayDate = new Date();
	   let shippingDays = this.config.forecast.shippingDays ? this.available_days : weekdays.slice(0, 5),
		   todayDay = todayDate.toLocaleDateString('it-IT', { weekday: 'long' }),
		   todayTime = todayDate.toLocaleTimeString('it-IT');
	   let shippingDay = todayDay;
	   const getDeliveryDate = (addDays, deliveryDays, diff = false) => {
		   var daysAvailability = {};
		   weekdays.forEach((e, i) => {
			   if (shippingDays.includes(e)) { daysAvailability[e] = true } else { daysAvailability[e] = false }
		   })

		   if (todayTime > this.lastShippingT && daysAvailability[shippingDay] == true) {
			   addDays = parseInt(addDays) + 1;
		   }
		   
		   shippingDay = this.dayIncrement(daysAvailability, shippingDay, addDays).day;
		   let shippingAdd = this.dayIncrement(daysAvailability, shippingDay, addDays).addDays;
		   var deliveryDate = new Date(Date.now() + addDays * 24 * 60 * 60 * 1000);
		   
		   var deliveryDay = deliveryDate.toLocaleDateString('it-IT', { weekday: 'long' });
		   deliveryDay = this.dayIncrement(deliveryDays, deliveryDay, addDays).day
		   addDays = this.dayIncrement(deliveryDays, deliveryDay, addDays).addDays
		   let add = addDays + shippingAdd;
		   if(diff) {
			add -= diff
		   }
		   deliveryDate = new Date(Date.now() + add * 24 * 60 * 60 * 1000)
		   deliveryDate = new Date(Date.now() + add * 24 * 60 * 60 * 1000)

		   let finalDeliveryDay = deliveryDate.toLocaleDateString('it-IT', { weekday: 'long', day: '2-digit', month: 'long' })
		   return finalDeliveryDay
	   }

	   weekdays.forEach(e => {
		   this.available_days.includes(e) ? deliveryDays[e] = true : deliveryDays[e] = false;
	   })

	   this.lastShippingT = !this.config.forecast.lastShippingT ? '15:00' : this.config.forecast.lastShippingT;
	   
	   const min = getDeliveryDate(addDays_min, deliveryDays);
	   const max = getDeliveryDate(addDays_max, deliveryDays, addDays_max - addDays_min);
	   
	   return [min, max]
   }
}

hoculus.resetFilter = function () {
	let el = document.querySelector("[data-hoculus-prevent]");
	if(!el) return;
	el.addEventListener("click", function (ev) {
		ev.preventDefault();
		if(location.href === el.href) return;
		location.href = el.href
	})
}


hoculus.discountTable = {
	selectors:{
		discountData: '[data-table-discount-by-product]'
	},
	init: function(){
		subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
			hoculus.discountTable.fetchAll(event.data.variant.price/100)
		})
	},
	fetchAll: function(price = false){
		document.querySelectorAll(hoculus.discountTable.selectors.discountData).forEach(e => new hoculus.discountTable.discountRowData(e,price));
	},
	discountRowData: class{
		constructor(el,price = false){
			this.element = el;
			this.price = price;
			this.price == false ? this.price = parseInt(this.element.dataset.tableDiscountOriginalPrice)/100 : 0;
			this.discount = parseFloat(this.element.dataset.tableDiscountByProduct);
			
			var amount = Shopify.formatMoney((100-this.discount)*this.price,this.element.dataset.tableDiscountMoneyFormat);
			this.element.innerHTML = '<b>'+amount+'</b>';
		}
	}
}


hoculus.cartProgress = {
	init: () => {
		if (!hoculus.shipping?.enable) return;
		let forms = document.querySelectorAll("[data-type=\"add-to-cart-form\"]")
		forms.forEach(form => {
			form.addEventListener("submit", async (ev) => {
				ev.preventDefault();
				ev.stopImmediatePropagation();
				ev.stopPropagation();
				const cart = await hoculus.utils.getCart();
				hoculus.cartProgress.update(cart);
			})
		})

		document.addEventListener("hoculus:product:added", async function () {
			const cart = await hoculus.utils.getCart()
			hoculus.cartProgress.update(cart)
		});
	},
	update: (cart) => {
		if (!hoculus.shipping?.enable) return;
		var progressContainers = document.querySelectorAll(".hoculus.cart_progress")
		var {total_price, item_count} = cart
		
		progressContainers.forEach(progressContainer => {
			progressContainer.dataset.itemCount = item_count
			var subtotalCurrency = Shopify.formatMoney(total_price, hoculus.settings.moneyFormat);
			var progressBar = progressContainer.querySelector('.progress_line_main');
			var progressBarPrice = progressContainer.querySelector('.progress_line_main .progress_line_price');
			var text = progressContainer.querySelector('.cart_progress_text');
			var percentage = Math.round(total_price/hoculus.shipping?.maxValue);	

			progressBar.style.width = percentage+'%';
			progressBarPrice.innerHTML = subtotalCurrency;
			text.innerHTML = (percentage>=100) ? 
				hoculus.shipping?.messages?.success.replace("[valore]", Shopify.formatMoney((parseInt(hoculus.shipping?.maxValue) * 100), hoculus.settings.moneyFormat))
				: hoculus.shipping?.messages?.default.replace("[mancante]", Shopify.formatMoney((parseInt(hoculus.shipping?.maxValue)*100-parseInt(total_price)),hoculus.settings.moneyFormat));
		})
	}
}

hoculus.cartCrossSellSlider = {
	containerSelector: '#hoculus-cross-sell-slider',
	sliderSelector: '.hoculus-cross-sell__slider-container',
	slidesContainer: '.hoculus-cross-sell__slides',
	listenFor: ['hoculus:product:add', "hoculus:product:remove", "hoculus:cart:update"],
	outputAttribute: 'data-hoculus-cross-sell-output',
	triggersAttribute: 'data-hoculus-cross-sell-triggers',
	init: function(){
		if(document.querySelector(hoculus.cartCrossSellSlider.containerSelector)){
			hoculus.cartCrossSellSlider.listenFor.forEach(e => {
				document.addEventListener(e, function(evt) {
					console.log(e)
				 	hoculus.cartCrossSellSlider.updateSlider(evt);
				});
			})
			hoculus.cartCrossSellSlider.updateSlider();
		}
	},
	updateSlider: function(evt = false){
		let slider = document.querySelector(hoculus.cartCrossSellSlider.containerSelector);
		let slides = document.querySelectorAll('['+hoculus.cartCrossSellSlider.outputAttribute+']');
		hoculus.utils.getCart().then(data => {
			let toDisplay = [];
			let cartItemsIds = data.items.map(function (el) { return el.product_id; });
			cartItemsIds.forEach(id => {
				var iterDisplay = document.querySelectorAll('['+hoculus.cartCrossSellSlider.triggersAttribute+'*="'+id+'"]');
				iterDisplay.length > 0 ? iterDisplay.forEach(iter => {!toDisplay.includes(iter) && !cartItemsIds.includes(parseInt(iter.dataset.hoculusCrossSellOutput)) ? toDisplay.push(iter) : 0}) : 0;
			})
			slider.classList.add('hidden');
			slides.forEach(slide => toDisplay.includes(slide) ? slide.classList.remove('hidden') : slide.classList.add('hidden'));
			toDisplay.length > 0 ? (slider.classList.remove('hidden'),evt != false ? slider.querySelector(hoculus.cartCrossSellSlider.sliderSelector).scrollLeft = 0 : 0) : 0;
		})
	}
}

hoculus.productPageShowDiscount = {
	selectors: {
		wrapper: "product-info",
		optionWrapper: "variant-radios",
		optionsField: "fieldset.product-form__input",
		optionFieldValue: "input",
		listenFor: "hoculus:variant:selected",
		rulesWrapper: "product-info [data-hoculus-rules]",
		rulesWrapperDataset: "hoculusRules",
		messageWrapperDataset:  "discountMessage",
		regex: /\d+/,
		insertAfter: "product-info .price__container",
		discountContainer: ".hoculus-discount-container",
		replaceForMessage: "[val]",
		isCheckedOption: ".product-form__input input[type=radio]:checked+label"
	},
	needStart: false,
	init: function () {
		this.wrapper = document.querySelector(this.selectors.wrapper);
		this.optionWrapper = document.querySelector(this.selectors.optionWrapper)
		this.optionsField = document.querySelector(this.selectors.optionsField);
		if(!this.optionsField) return;
		this.optionsValues = Array.from(this.optionsField.querySelectorAll(this.selectors.optionFieldValue)).map(input => input.value);
		this.checkHasDiscount();
	},
	checkHasDiscount: function () {
		this.rulesWrapper = document.querySelector(this.selectors.rulesWrapper)
		if(!this.rulesWrapper) return;
		this.discountRules = this.rulesWrapper.dataset[this.selectors.rulesWrapperDataset].split("\n");
		this.discountRules.forEach(rule => this.checkRule(rule));
		
		if(!this.needStart) return;
		
		this.message = this.rulesWrapper.dataset[this.selectors.messageWrapperDataset];
		this.variantsData = JSON.parse(this.optionWrapper.querySelector('script[type="application/json"]').textContent);
		this.minorPrice = this.findMinorPrice(this.variantsData, 'price');
		this.insertAfter = document.querySelector(this.selectors.insertAfter);

		this.discountContainer = this.wrapper.querySelector(this.selectors.discountContainer)
		this.listenEvent(false)
		document.addEventListener(this.selectors.listenFor, this.listenEvent.bind(this))
	},
	checkRule: function (rule) {
		if(this.needStart) return false;		
		this.needStart = this.optionsValues.some(option => {
			let _option = option.toLowerCase();
			if(!option.match(this.selectors.regex)) return false;
			let str = rule.replace("[num] ", "").toLowerCase();
			if(_option.includes(str)) return true;
		});
	},
	listenEvent: function (ev) {
		const _ev = {
			detail: {
				option: document.querySelector(this.selectors.isCheckedOption)
			}
		}
		ev = ev || _ev

		const opt = ev.detail.option?.innerText || ev.detail.option;

		console.log(opt)
		const variantData = this.variantsData.filter(data => data.title === opt)[0]
		const variantCount = this.extractNumbersFromString(opt);
		const price = variantData.price;
		const discount = this.minorPrice * variantCount - price;
		!discount ? this.removeText() : this.setText(Shopify.formatMoney(this.minorPrice * variantCount - price), Shopify.money_format);
	},
	removeText: function () {
		this.discountContainer.style.display = "none";
	},
	setText: function (text) {
		this.discountContainer.style.display = "flex";
		this.discountContainer.innerHTML = `${this.message.replace(this.selectors.replaceForMessage, text)}`
	},
	findMinorPrice: function (array, key) {
		if (array.length === 0) {
		  return null; // Return null for an empty array
		}
	  
		let minObject = array[0]; // Assume the first object has the minimum price initially
		let minValue = minObject[key];
	  
		array.reduce((min, current) => {
		  if (current[key] < minValue) {
			minObject = current;
			minValue = current[key];
		  }
		  return min; // The reduce function requires returning a value, but it's not used here
		});
	  
		return minObject[key];
	},
	extractNumbersFromString: function (inputString) {
		const regex = /\d+/g; // Regular expression to match one or more digits
		const matches = inputString.match(regex);
		
		if (matches) {
		  return matches.join(''); // Concatenate all matched digits into a single string
		} else {
		  return ''; // Return an empty string if no numbers are found
		}
	}
}

hoculus.utils.domreadyState().then(resp => {
    hoculus.discountTable.init();
	hoculus.resetFilter();
	new hoculus.Shipping();
	hoculus.cartProgress.init();
	hoculus.cartCrossSellSlider.init();
	hoculus.productPageShowDiscount.init();
	["click","scroll","touchstart","mousemove"].forEach(function(evt) {
		document.addEventListener(evt, hoculus.utils.onInteraction, { passive: false })
	})
});
